var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.loaded),expression:"!loaded"}],attrs:{"id":"map-container"}},[_c('div',{style:({ height: _vm.height }),attrs:{"id":"map-info"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }